import { useExchangeRate } from "@/components/home/ExchangeRateProvider";
import { Landmark } from "lucide-react";

const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
};

export const ExchangeRateBadge = ({ compact = false }) => {
  const { rate, date, loading, error, stale } = useExchangeRate();
  if (loading) return <span className="text-sm text-gray-400" data-testid="fx-badge-loading">Consultando tipo de cambio Banxico…</span>;
  if (error || !rate) return <span className="text-sm text-gray-400" data-testid="fx-badge-error">Tipo de cambio no disponible por el momento</span>;
  const rateText = rate.toLocaleString("es-MX", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
  if (compact) {
    return (
      <span className="inline-flex items-center gap-1.5 font-medium" data-testid="fx-badge-compact">
        <Landmark className="w-4 h-4 shrink-0" /> Tipo de cambio FIX Banxico hoy: <b data-testid="fx-rate-compact">${rateText} MXN</b> por USD
      </span>
    );
  }
  return (
    <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 rounded-2xl bg-white border border-orange-200 px-4 py-3 shadow-sm" data-testid="fx-badge">
      <span className="w-9 h-9 rounded-xl bg-brand-orange/10 text-brand-orange grid place-items-center"><Landmark className="w-5 h-5" /></span>
      <div className="text-sm">
        <p className="font-semibold text-brand-carbon">1 USD = <span className="text-brand-orange" data-testid="fx-rate">${rateText} MXN</span></p>
        <p className="text-gray-500 text-xs">Tipo de cambio FIX publicado por el Banco de México · {fmtDate(date)}{stale ? " (último disponible)" : ""}</p>
      </div>
    </div>
  );
};

export default ExchangeRateBadge;
